module.exports = __webpack_public_path__ + "files/ea67228cd04b04478512abe8e39ffb1b.svg";